import { Box, Typography } from '@mui/material';
import { DummyCodePage } from '@trinity/custom-pages-registry';
import type { BuiltInCodePage } from '@trinity/management-app-client';

type Props = {
  codePage: BuiltInCodePage;
  pageName: string;
};

export function CustomCodeRenderer({ codePage, pageName }: Props): React.ReactElement {
  switch (codePage) {
    case 'dummy':
      return <DummyCodePage pageName={pageName} />;
    default:
      return (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            This code page is not available yet.
          </Typography>
        </Box>
      );
  }
}
